import matchList from '@gin-betting/match-list';

import {
    matchListRoutes,
    OUTRIGHTS_LIMIT_PER_PAGE,
    POLLING_EDGE_PAGE,
} from 'app-constants';
import { getMatchesLimitPerPage } from './utils';

export const paginationReducer = () =>
    matchList.pagination.reducer({
        matchesLimitPerPage: getMatchesLimitPerPage(),
        outrightsLimitPerPage: OUTRIGHTS_LIMIT_PER_PAGE,
        pollingEdgePage: POLLING_EDGE_PAGE,
        routes: matchListRoutes,
    });

export default () =>
    matchList.reducer(getMatchesLimitPerPage(), matchListRoutes);
